<div class="flex flex-col gap-4">
  @if (loadError()) {
    <div class="flex items-center gap-2 rounded-xl bg-status-error p-3 text-error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ 'alarmsPage.overview.loadError' | translate }}</span>
    </div>
  }

  <div class="grid grid-cols-4 gap-4">
    <div class="flex flex-col justify-between gap-1">
      <xemex-stat-card
        [label]="'alarmsPage.overview.kpi.totalOpen' | translate"
        [value]="kpis().openNow"
        [delta]="kpis().openDeltaStr"
        [deltaLabel]="'alarmsPage.overview.kpi.vsLastWeek' | translate"
        deltaGood="down"
      ></xemex-stat-card>

      <xemex-stat-card
        [label]="'alarmsPage.overview.kpi.avgResolution' | translate"
        [value]="kpis().avgResStr"
        deltaGood="down"
      ></xemex-stat-card>

      <xemex-stat-card
        [label]="'alarmsPage.overview.kpi.openedLast7Days' | translate"
        [value]="kpis().openedLast7"
        [secondary]="('alarmsPage.overview.kpi.avgPerDay' | translate: { value: kpis().avgPerDay })"
      ></xemex-stat-card>
    </div>

    <xemex-card [title]="'alarmsPage.overview.chart.title' | translate" class="col-span-3">
      <xemex-chart
        [labels]="chartLabels()"
        [datasets]="chartDatasets()"
        chartType="line"
        heightClass="h-40"
        [filled]="true"
      ></xemex-chart>
    </xemex-card>
  </div>

  <xemex-table [data]="tableData()" [columns]="columns" [pageable]="true" [rowLink]="rowLink">
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [initialFilters]="initialFilters()"
      [searchPlaceholder]="'alarmsPage.overview.filters.searchPlaceholder' | translate"
      (searchChange)="query.set($event)"
      (filterChange)="activeFilters.set($event)"
    ></xemex-table-filter-bar>
  </xemex-table>
</div>
